import React from "react";
import { useState, useEffect } from "react";
import PieChart from "./PieChart";
import { groupAndTransform } from "../utils";

const ChartsSection = ({ deals, investments }) => {
  const [byStructureData, setByStructureData] = useState([]);
  const [bySubassetData, setBySubassetData] = useState([]);
  const [byGeographyData, setByGeographyData] = useState([]);

  useEffect(() => {
    const updatedData = deals
      .map((deal) => {
        const matchingInvestment = investments.find(
          (investment) => investment.name === deal.Deals
        );
        return {
          ...deal,
          ...matchingInvestment,
        };
      })
      .filter((deal) =>
        investments.some((investment) => investment.name === deal.Deals)
      );
    setByStructureData(groupAndTransform(updatedData, "Structure"));
    setBySubassetData(groupAndTransform(updatedData, "Sector"));
    setByGeographyData(groupAndTransform(updatedData, "Countries"));
  }, [investments, deals]);

  return (
    <div>
      <h2
        className="bg-vennre-blue text-sm md:text-lg text-white font-semibold px-6 py-2 sm:rounded-t-lg"
        data-section-title
      >
        Portfolio Snapshot
      </h2>
      <div className="grid gap-6 md:grid-cols-3">
        <div className="flex items-center justify-center bg-white p-4 shadow-md rounded-lg">
          <PieChart title="By Structure" data={byStructureData} />
        </div>
        <div className="flex items-center justify-center bg-white p-4 shadow-md rounded-lg">
          <PieChart title="By Sector" data={bySubassetData} />
        </div>
        <div className="flex items-center justify-center bg-white p-4 shadow-md rounded-lg">
          <PieChart title="By Geography" data={byGeographyData} />
        </div>
      </div>
    </div>
  );
};

export default ChartsSection;
